/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserInfoDto } from '../../models/platform-api-result-of-user-info-dto';
import { PlatformAuthenticateUserAccount } from '../../models/platform-authenticate-user-account';

export interface PostUseraccountsActionAuthenticate$Params {
      body: PlatformAuthenticateUserAccount
}

export function postUseraccountsActionAuthenticate(http: HttpClient, rootUrl: string, params: PostUseraccountsActionAuthenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfoDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionAuthenticate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserInfoDto>;
    })
  );
}

postUseraccountsActionAuthenticate.PATH = '/api/useraccounts/action/authenticate';
